import { axios } from '@/router/request'
import signMd5Utils from "@/wincourse/utils/encryption/signMd5Utils";

function analysePluginUrl(url) {
    let finalUrl = url
    if (url.indexOf('${pluginPerfix}') >= 0) {
        let pluginId = process.env.VUE_APP_PLUGIN_ID
        if (pluginId) {
            finalUrl = url.replace('${pluginPerfix}', '/api/plugins/' + pluginId)
        } else {
            finalUrl = url.replace('${pluginPerfix}', '')
        }
    }
    return finalUrl
}

// post
export function postAction(url, parameter) {
    url = analysePluginUrl(url)
    let sign = signMd5Utils.getSign(url, parameter)
    //将签名和时间戳，添加在请求接口 Header
    let signHeader = { 'X-Sign': sign, 'X-TIMESTAMP': signMd5Utils.getDateTimeToString() }

    return axios({
        url: url,
        method: 'post',
        data: parameter,
        headers: signHeader
    })
}

// get
export function getAction(url, parameter) {
    //将签名和时间戳，添加在请求接口 Header
    return axios({
        url: url,
        method: "get",
        params: parameter,
    });
}
